import {inject, injectable} from "inversify";
import {makeAutoObservable} from "mobx";
import {ViewController} from "data/types/structure";
import {burgerMenuLinks, landingSubNavigation} from "data/constants/navigation";
import {Bindings} from "data/constants/bindings";
import {type ILocalizationStore} from "data/stores/localization/localization.store";
import {type IUserStore} from "data/stores/user/user.store";
import {IBurgerNavItem, type ISubNavItem} from "data/types/navigation";

export interface ILandingLayoutController extends ViewController {
	subNavItems: ISubNavItem[];
	burgerNavItems: IBurgerNavItem[];
}

@injectable()
export class LandingLayoutController implements ILandingLayoutController {
	get isAuthorized() {
		return this._userStore.isAuthorized;
	}

	get subNavItems() {
		return landingSubNavigation.filter(({isPrivate}) => (isPrivate ? this.isAuthorized : true));
	}

	get burgerNavItems() {
		return burgerMenuLinks.filter(({isPrivate}) => (isPrivate ? this.isAuthorized : true));
	}

	constructor(
		@inject(Bindings.LocalizationStore) public readonly i18n: ILocalizationStore,
		@inject(Bindings.UserStore) private _userStore: IUserStore
	) {
		makeAutoObservable(this);
	}
}
